export default __webpack_public_path__ + "static/media/schedule-clock.4f34f35a.svg";